import type React from 'react'
import type { ReactElement } from 'react'

export function IconDeposit(props: React.SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg width={54} height={50} viewBox={'0 0 54 50'} fill={'none'} xmlns={'http://www.w3.org/2000/svg'} {...props}>
      <path
        d={
          'M25.9393 38.0607C26.5251 38.6464 27.4749 38.6464 28.0607 38.0607L37.6066 28.5147C38.1924 27.9289 38.1924 26.9792 37.6066 26.3934C37.0208 25.8076 36.0711 25.8076 35.4853 26.3934L27 34.8787L18.5147 26.3934C17.9289 25.8076 16.9792 25.8076 16.3934 26.3934C15.8076 26.9792 15.8076 27.9289 16.3934 28.5147L25.9393 38.0607ZM27 0L25.5 0L25.5 37H27H28.5L28.5 0L27 0Z'
        }
        fill={'currentColor'}
      />
      <path
        d={
          'M48 17C51.3137 17 54 19.6863 54 23V44L53.9922 44.3086C53.8367 47.3767 51.3767 49.8367 48.3086 49.9922L48 50H6L5.69141 49.9922C2.62332 49.8367 0.163251 47.3767 0.0078125 44.3086L0 44V23C9.66416e-08 19.6863 2.68629 17 6 17H19V20H6C4.34315 20 3 21.3431 3 23V44C3 45.6569 4.34315 47 6 47H48C49.6569 47 51 45.6569 51 44V23C51 21.3431 49.6569 20 48 20H34V17H48Z'
        }
        fill={'currentColor'}
      />
    </svg>
  )
}
